import React, { useEffect, useRef, useState } from "react";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import "./Myprofile.css";
import gift from "../../assets/gift.png";
import wallet from "../../assets/wallet.png";
import arrow from "../../assets/arrow.png";
import Profileleft from "./Profileleft";
import EncryptDecrypt from "../../common/Crypto";
import { message } from "antd";
import String from "../../lang/String";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubMenu from "antd/es/menu/SubMenu";
import { data } from "jquery";
import { MutatingDots, TailSpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import store from "../../redux/Store";
import $ from "jquery";
import { images } from "../../common/Images";

const Myprofile = () => {
  // const [profile, setProfile] = useState("profile");
  const [cusId, setcusId] = useState(0);
  const [firstname, setFirstname] = useState(false);
  const [lastname, setLastname] = useState(false);
  const [email, setEmail] = useState(false);
  const [phone, setPhone] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [Email, setemail] = useState("");
  const [Phone, setphone] = useState("");
  const [cusdetails, setCusdetails] = useState({});
  const [err, setErr] = useState(false);
  const [sendbtn, setSendbtn] = useState(false);
  const [loaders, setLoaders] = useState(false);

  const codeRef = useRef();
  const navigate = useNavigate();
  const [profileerr, setProfileError] = useState({
    firstname_error: "",
    lastname_error: "",
    email_error: "",
    phonenumber_error: "",
  });
  const user = useSelector((state) => state.auth.user);

  const handleProfileapi = () => {
    setLoaders(true);
    const profileParams = { id: user.id };
    ApiCall("profileView", profileParams)
      .then((data) => {
        if (data.message == "Success.") {
          store.dispatch({ type: "userupdate", payload: data.data });
          setCusdetails(data.data);
          setFirstName(data.data.first_name);
          setLastName(data.data.last_name);
          setemail(data.data.email);
          setphone(data.data.phone_number);
          setLoaders(false);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    let isAuth = localStorage.getItem("customerId");
    if (isAuth && isAuth !== null) {
      handleProfileapi();
    } else {
      navigate("/");
    }
  }, []);

  const profileUpdateHandler = (e) => {
    setSendbtn(true);
    e.preventDefault();
    if (loginValidation()) {
      setProfileError("");
      const updateParams = {
        id: user.id,
        first_name: firstName,
        last_name: lastName,
        phone_number: Phone,
      };
      ApiCall("updateProfile", updateParams)
        .then((data) => {
          if (data.message == "Success.") {
            setSendbtn(false);
            toast.success("Upated Successfully", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              limit: 1,
            });
          } else {
            setSendbtn(false);
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          setSendbtn(false);
          toast.error("Request Failed, try again!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const loginValidation = () => {
    let lastAtPos = Email.lastIndexOf("@");
    let lastDotPos = Email.lastIndexOf(".");
    const reg = /^[0-9\b]+$/;

    let isValid = true;
    if (firstName == "") {
      // setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        firstname_error: String.profile.first_required,
      }));
      setFirstname(true);
    } else {
      setFirstname(false);
    }

    if (lastName == "") {
      // setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        lastname_error: String.profile.last_required,
      }));
      setLastname(true);
    } else {
      setLastname(false);
    }
    if (Email == "") {
      //  setErr(true);
      isValid = false;
      setSendbtn(false);

      setProfileError((prevError) => ({
        ...prevError,
        email_error: String.profile.enter_email,
      }));
      setEmail(true);
    } else if (
      !(
        lastAtPos < lastDotPos &&
        lastAtPos > 0 &&
        Email.indexOf("@@") === -1 &&
        lastDotPos > 2
      )
    ) {
      //  setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        email_error: String.profile.valid_email,
      }));
      setEmail(true);
    } else {
      setEmail(false);
    }

    if (Phone == "") {
      // setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        phonenumber_error: String.profile.phone_requried,
      }));
      setPhone(true);
    } else if (reg.test(Phone) === false) {
      // setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        phonenumber_error: String.profile.phone_valid,
      }));
      setPhone(true);
    } else if ((Phone && Phone.length > 10) || (Phone && Phone.length < 10)) {
      // setErr(true);
      isValid = false;
      setSendbtn(false);
      setProfileError((prevError) => ({
        ...prevError,
        phonenumber_error: String.profile.phone_min,
      }));
      setPhone(true);
    }
    // else if(Phone == cusdetails.phone_number){
    //      isValid = false;
    //      setSendbtn(false);
    //      setProfileError((prevError) => ({
    //        ...prevError,
    //        phonenumber_error: String.profile.already_exist,
    //      }));
    //      setPhone(true);
    // }
    else {
      setPhone(false);
    }
    // setSendbtn(false);

    return isValid;
  };

  const copyClipBoard = () => {
    // var copy_text = navigator.clipboard.writeText(codeRef.current.textContent);
    var copy_text = navigator.clipboard.writeText($("#referal_codess").text());

    toast.success("Copied", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <>
      <Header make={true} />
      <div
        className="myprofilebox "
        style={{ backgroundColor: "#fef4f7", height: "100%" }}
      >
        <div style={{ width: "250px" }}>
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-5">
              <a href="javascript:history.go(-1)">
                <button   
                  className="btn btn-basic p-0"
                  style={{ background: Colors.Base_color, color: "white" }}
                >
                  <img src={images.left} width={30} />
                  <span
                    style={{ position: "relative", left: "-8px", top: "2px" }}
                  >
                    Back
                  </span>
                </button>
              </a>
            </div>
            <div className="col-7" style={{ paddingTop: "7px" }}>
              <h4>User Profile</h4>
            </div>
          </div>
        </div>
        <div
          className="profilecontainer row mx-0 gap-4"
          style={{ paddingTop: "20px", height: "100%", paddingBottom: "20px" }}
        >
          <Profileleft
          // id={cusdetails.id}
          // first_name={cusdetails.first_name}
          // avatar={cusdetails.avatar}
          />
          <div
            className="right col-11 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
            style={{
              backgroundColor: Colors.white_color,
              height: "max-content",
              borderRadius: "20px",
              marginBottom: "40px",
            }}
          >
            {loaders === false ? (
              <div className="right-side w-100">
                <div>
                  <span className="personal-in">Personal Info</span>
                  <div className="form-container">
                    <form
                      className="personaldetails"
                      onSubmit={profileUpdateHandler}
                    >
                      <label>First Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="fname"
                        name="fname"
                        aria-describedby="fname"
                        value={firstName}
                        // defaultValue={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                      <div
                        className="err"
                        style={{ display: firstname ? "block" : "none" }}
                      >
                        {profileerr.firstname_error}
                      </div>
                      <label>Last Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="lname"
                        name="lname"
                        aria-describedby="lname"
                        value={lastName}
                        // defaultValue={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                      <div
                        className="err"
                        style={{ display: lastname ? "block" : "none" }}
                      >
                        {profileerr.lastname_error}
                      </div>

                      <label>Email Address</label>
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        name="email"
                        aria-describedby="email"
                        value={Email}
                        // defaultValue={Email}
                        onChange={(e) => setemail(e.target.value)}
                        readOnly
                      />
                      <div
                        className="err"
                        style={{ display: email ? "block" : "none" }}
                      >
                        {profileerr.email_error}
                      </div>

                      <label>Phone Number</label>
                      <input
                        type="number"
                        class="form-control"
                        id="phone_num"
                        name="phone_number"
                        aria-describedby="phone_num"
                        value={Phone}
                        // defaultValue={Phone}

                        onChange={(e) => setphone(e.target.value)}
                      />
                      <div
                        className="err"
                        style={{ display: phone ? "block" : "none" }}
                      >
                        {profileerr.phonenumber_error}
                      </div>

                      {/* <div className="wallet-earned pt-4 d-flex flex-column gap-3">
                        <div
                          className="first-half"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/wallet")}
                        >
                          <div className="wallet-text d-flex align-items-center ">
                            <img src={wallet}></img>
                            <div className="inner-text">
                              <span>Wallet Balance</span> <br></br>
                              <span>₹{user?.wallet_amount}</span>
                            </div>
                          </div>
                          <img src={arrow} className="arrows"></img>
                        </div>
                        <div
                          className="second-half"
                          style={{ cursor: "pointer" }}
                          onClick={() => navigate("/total-earned")}
                        >
                          <div className="wallet-text d-flex align-items-center">
                            <img src={gift}></img>
                            <div className="inner-text">
                              <span>Total Earned</span> <br></br>
                              <span>
                                {user?.coins} <small>coins</small>
                              </span>
                            </div>
                          </div>
                          <img src={arrow} className="arrows"></img>
                        </div>
                      </div> */}
                      {/* <div className="referal_code container  w-50">
                      <div className="row d-flex flex-column gap-2">
                        <span>Sent Referal Code</span>
                        <span>b4ecfd2a</span>
                      </div>
                      <i class="fa-solid fa-share"></i>
                    </div> */}
                      <div
                        className="container"
                        style={{ paddingTop: "1.5rem" }}
                      >
                        <div className="row">
                          <div className="col-xxl-5" style={{
                            width:'100%'
                          }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex flex-column referals">
                                <span className="sent_referals">
                                  Share Referral Code
                                </span>
                                <span id="referal_codess" ref={codeRef}>
                                  {user && user.my_referral_code}
                                </span>
                              </div>
                              <i
                                class="fa-solid fa-share-nodes share_icon"
                                style={{ cursor: "pointer" }}
                                onClick={() => copyClipBoard()}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=" savebtn d-flex justify-content-center pt-5">
                        <button
                          type="submit"
                          className="btn btn-lg "
                          disabled={sendbtn}
                        >
                          {!sendbtn ? (
                            "Save & Update"
                          ) : (
                            <TailSpin
                              height="30"
                              width="100"
                              color="#126a38"
                              ariaLabel="tail-spin-loading"
                              radius="1"
                              wrapperStyle={{ justifyContent: "center" }}
                              wrapperClass=""
                              visible={true}
                            />
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="d-flex align-items-center justify-content-center w-100"
                style={{ height: "100vh" }}
              >
                <MutatingDots
                  height="100"
                  width="100"
                  color={Colors.Base_color}
                  secondaryColor={Colors.Base_color}
                  radius="12.5"
                  ariaLabel="mutating-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer limit={1} />
      <Footer />
    </>
  );
};

export default Myprofile;
